(function(){
  window.addEventListener('DOMContentLoaded',()=>{
    const triggers = document.querySelectorAll('[data-modal]');
    if(triggers.length && ProductMedias){
      Modal(triggers);
    }
  });

  const Modal = (triggers)=>{
    const {modalEl , closeEl} = constructor();
    Array.from(triggers).forEach(trigger => {
      trigger.addEventListener('click',()=>{
        open(modalEl,trigger.dataset.modal);
      });
    });
    closeEl.addEventListener('click',()=>{
      close(modalEl);
    })
  }

  const constructor = ()=>{
    // modal create
    const modal_el = document.createElement('div');
    modal_el.className = 'gallery-modal';

    // modal close
    const close_el = document.createElement('button');
    close_el.type = 'button';
    close_el.textContent = 'CLOSE';
    close_el.className = 'gallery-modal__close';
    modal_el.appendChild(close_el);

    // modal images
    const list_el = document.createElement('ul');
    list_el.className = 'unstyled-list';
    ProductMedias.forEach(media=>{
      const li_el = document.createElement('li');
      li_el.insertAdjacentHTML('beforeend',media.html);
      li_el.id = 'media-'+media.id;
      list_el.appendChild(li_el);
    });

    modal_el.appendChild(list_el);
    document.body.appendChild(modal_el);
    return { modalEl:modal_el, closeEl:close_el };
  }

  const open =(modal,id)=>{
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    document.body.style.overflow = 'hidden';
    const mediaEl = document.getElementById( `media-${id}`);
    const rect = mediaEl.getBoundingClientRect();
    const top = rect.top;
    modal.scrollBy({
      top,
      behavior: "smooth",
    })
  }

  const close =(modal)=>{
    modal.style.visibility = 'hidden';
    modal.style.opacity = '0';
    document.body.style.overflow = '';
  }

})();